/* DRAFT — PENDING LEGAL REVIEW */
import React from "react";
import PageShell from "../../components/layout/PageShell";
import Container from "../../components/primitives/Container";
import Section from "../../components/primitives/Section";
import Eyebrow from "../../components/primitives/Eyebrow";
import Reveal from "../../components/primitives/Reveal";
import SeoHead from "../../components/seo/SeoHead";
import DraftBanner from "../../components/legal/DraftBanner";

const H2 = ({ children }) => (
  <h2
    className="mt-12 font-serif font-normal text-navy text-balance"
    style={{ fontSize: "clamp(26px, 3vw, 36px)", lineHeight: 1.2, letterSpacing: "-0.005em" }}
  >
    {children}
  </h2>
);

const P = ({ children, ...rest }) => (
  <p
    {...rest}
    className="mt-6 font-sans text-[16px] sm:text-[16.5px] leading-[1.75] text-navy/80 max-w-prose"
  >
    {children}
  </p>
);

const LegalNotice = () => {
  return (
    <PageShell>
      <SeoHead
        title="Legal Notice"
        description="Publisher information and legal disclosures for the Quantum US Capital Partners website."
        path="/legal/notice"
        noIndex
      >
        <meta name="x-document-status" content="draft-pending-legal-review" />
      </SeoHead>

      <Section tone="light" className="pt-28 md:pt-32 lg:pt-36 pb-20 md:pb-24">
        <Container>
          <Reveal className="max-w-3xl">
            <DraftBanner />
            <div className="mt-8">
              <Eyebrow tone="muted">Legal</Eyebrow>
            </div>
            <h1
              className="mt-8 font-serif font-normal text-navy text-balance"
              data-testid="notice-title"
              style={{ fontSize: "clamp(40px, 5.5vw, 80px)", lineHeight: 1.05, letterSpacing: "-0.01em" }}
            >
              Legal Notice.
            </h1>
            <span aria-hidden="true" className="mt-10 block h-px w-12 bg-gold" />
            <p
              className="mt-10 font-sans uppercase text-navy/55"
              style={{ fontSize: "11px", letterSpacing: "0.22em" }}
              data-testid="notice-effective"
            >
              Effective February 2026
            </p>
          </Reveal>

          <Reveal className="mt-10 max-w-3xl">
            <P>
              This Legal Notice is provided in respect of the website
              quscap.com (the &ldquo;Site&rdquo;) and identifies the entity
              responsible for its publication. It should be read together with
              our{" "}
              <a
                href="/legal/terms"
                className="text-navy underline decoration-gold underline-offset-4 hover:text-gold transition-colors"
              >
                Terms of Use
              </a>
              {" "}and{" "}
              <a
                href="/legal/privacy"
                className="text-navy underline decoration-gold underline-offset-4 hover:text-gold transition-colors"
              >
                Privacy Policy
              </a>
              .
            </P>

            <H2>Publisher</H2>
            <P>
              Quantum US Capital Partners LLC, a limited liability company
              organised in the United States. Correspondence relating to this
              Site may be directed to the Office of the Chairman at{" "}
              <a
                href="mailto:chairman@quscap.com"
                className="text-navy underline decoration-gold underline-offset-4 hover:text-gold transition-colors"
                data-testid="notice-contact-email"
              >
                chairman@quscap.com
              </a>
              .
            </P>
            <P>
              Registered office and formation details will be updated upon
              completion of legal review.
            </P>

            <H2>Regulatory Status</H2>
            <P data-testid="notice-regulatory-statement">
              <strong className="font-medium text-navy">
                Quantum US Capital Partners LLC is a private investment
                institution. It is not a regulated investment manager, an
                alternative investment fund manager (AIFM), an investment
                adviser, or a broker-dealer, and does not manage client
                assets, solicit subscriptions to any regulated fund, or hold
                itself out as any of the foregoing.
              </strong>{" "}
              Investment activities described on the Site, where conducted
              under regulated frameworks, are undertaken through affiliated
              entities authorised in the relevant jurisdiction.
            </P>

            <H2>No Offer or Solicitation</H2>
            <P>
              Nothing on the Site constitutes, or should be construed as, an
              offer to sell or a solicitation of an offer to buy any security
              or interest in any vehicle, in any jurisdiction in which such
              an offer or solicitation would be unlawful. Any such offer or
              solicitation, where made, would be made only pursuant to
              definitive offering documents and only to persons who satisfy
              the conditions set forth therein.
            </P>

            <H2>Editorial Responsibility</H2>
            <P>
              Responsibility for the content of this Site rests with the
              Office of the Chairman of Quantum US Capital Partners LLC.
              Content is prepared in-house and, where relevant, in
              consultation with retained advisers. Material appearing in the
              Quantum Letters reflects the views of the Firm at the time of
              publication and is not updated except as expressly indicated.
            </P>

            <H2>Copyright and Trademarks</H2>
            <P>
              &copy; {new Date().getFullYear()} Quantum US Capital Partners
              LLC. All rights reserved. The name Quantum US Capital Partners,
              the tagline &ldquo;The Art of Capital,&rdquo; the wordmark, and
              the associated graphical marks appearing on the Site are used
              by Quantum and its affiliates and may not be reproduced,
              displayed, or otherwise employed without prior written
              permission. Full intellectual-property terms are set out in the
              Terms of Use.
            </P>

            <H2>Hosting and Technical Providers</H2>
            <P>
              Infrastructure and analytics vendors used to operate the Site
              are engaged under written terms restricting use of any
              information they process to the provision of services to
              Quantum. Details of vendors in use will be updated upon
              completion of legal review.
            </P>

            <H2>Contact</H2>
            <P>
              Legal correspondence should be addressed to the Office of the
              Chairman at{" "}
              <a
                href="mailto:chairman@quscap.com"
                className="text-navy underline decoration-gold underline-offset-4 hover:text-gold transition-colors"
              >
                chairman@quscap.com
              </a>
              .
            </P>
          </Reveal>
        </Container>
      </Section>
    </PageShell>
  );
};

export default LegalNotice;
